import { SAVE_LEVEL } from '../../../../constants/Level';
import { get, cloneDeep, isUndefined } from 'lodash';
import { Common } from '../../../../constants/ManageApps';

export function isActive(level, value, parentValue) {
    if (level === SAVE_LEVEL.HOTEL) {
        const isValueActive = value === Common.active.key;
        const isValueUndefined = isUndefined(value);
        const isValueInherit = value === Common.inherit.key;
        const isValueInheritedActiveStatus = (isValueUndefined || isValueInherit) && parentValue === Common.active.key;

        return isValueActive || isValueInheritedActiveStatus;
    } else if (level === SAVE_LEVEL.CHAIN) {
        return value === Common.active.key;
    } else {
        return false;
    }
}

export function normalizeThirdPartyObject(level, obj, defaultObj) {
    if (obj) {
        const normalizedObject = cloneDeep({
            ...defaultObj,
            ...obj
        });

        Object.keys(normalizedObject).forEach(objKey => {
            if (
                (normalizedObject[objKey].hasOwnProperty('status') ||
                    normalizedObject[objKey].hasOwnProperty('enabled')) &&
                !normalizedObject[objKey].status
            ) {
                if (normalizedObject[objKey].enabled === true) {
                    normalizedObject[objKey].status = Common.active.key;
                } else if (normalizedObject[objKey].enabled === false) {
                    normalizedObject[objKey].status = Common.inactive.key;
                } else {
                    normalizedObject[objKey].status =
                        level === SAVE_LEVEL.HOTEL ? Common.inherit.key : Common.inactive.key;
                }
            }

            delete normalizedObject[objKey].enabled;
        });

        return normalizedObject;
    }

    return obj;
}

export function getStatusValue(value, level) {
    if (level === SAVE_LEVEL.CHAIN && !value) {
        return Common.inactive.key;
    } else if (level === SAVE_LEVEL.HOTEL && (!value || value === 'inherit')) {
        return Common.inherit.key;
    } else {
        return value;
    }
}

export function getParentStatusValue(value, level) {
    return level !== SAVE_LEVEL.CHAIN && value ? value : Common.inactive.key;
}

export function getStatusOptions(parentValue, level) {
    return [
        { key: Common.active.key, label: Common.active.label },
        { key: Common.inactive.key, label: Common.inactive.label },
        ...(level !== SAVE_LEVEL.CHAIN
            ? [{ key: Common.inherit.key, label: `Same as chain settings (currently ${parentValue.toUpperCase()})` }]
            : [])
    ];
}

export function getThirdPartyConfigDataToShow(level, configurationObject, parentConfigurationObject) {
    const status = get(configurationObject, 'status');
    const chainStatus = get(parentConfigurationObject, 'status');
    const isInheritedData =
        level === SAVE_LEVEL.HOTEL && !isUndefined(status)
            ? status === Common.inherit.key
            : Common.inherit.key && chainStatus === Common.active.key;

    return {
        isInheritedData,
        data: isInheritedData ? parentConfigurationObject : configurationObject
    };
}



// WEBPACK FOOTER //
// ./src/components/pages/manage/apps/utils.js